import { ColorIconStyled } from "@digits-shared/components/UI/Elements/ColorIcon"
import { IconContainer, IconSVGContainer } from "@digits-shared/components/UI/Icons/Icon"
import { VibrantIcon } from "@digits-shared/components/UI/Icons/VibrantIcon"
import { css } from "styled-components"

export const squareIconStyles = (borderRadius: number) => css`
  ${IconContainer} {
    border: none;
    padding: 0;
  }

  ${IconSVGContainer}, ${ColorIconStyled}, ${VibrantIcon} {
    border-radius: ${borderRadius}px;
  }
`
